"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEventListener = void 0;
var react_1 = require("react");
var getElement_1 = require("./getElement");
var useEventListener = function (_a) {
    var type = _a.type, listener = _a.listener, _b = _a.element, element = _b === void 0 ? window : _b, options = _a.options;
    var savedListener = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        savedListener.current = listener;
    }, [listener]);
    var handleEventListener = (0, react_1.useCallback)(function (event) {
        var listener = savedListener.current;
        listener === null || listener === void 0 ? void 0 : listener(event);
    }, []);
    (0, react_1.useEffect)(function () {
        var target = (0, getElement_1.getElement)(element);
        target === null || target === void 0 ? void 0 : target.addEventListener(type, handleEventListener);
        return function () { return target === null || target === void 0 ? void 0 : target.removeEventListener(type, handleEventListener); };
    }, [type, element, options, handleEventListener]);
};
exports.useEventListener = useEventListener;
